import axios from "axios";
import apiConfig from "./config";
import * as Const from "../const";

const checkAccessToken = () => {
  let token;
  try {
    const pathnameItems = (window.location.pathname || "").split("/");
    if (pathnameItems[1] == "distributor") {
      token = window.localStorage.getItem(Const.TOKEN["distributor"]);
    } else if (pathnameItems[1] == "user") {
      token = window.localStorage.getItem(Const.TOKEN["user"]);
    } else if (pathnameItems[1] === "admin") {
      let adminType = window.localStorage.getItem(Const.ADMIN_TYPE);
      token = window.localStorage.getItem(Const.TOKEN[adminType]);
    }
  } catch (storageError) {
    token = null;
  }

  if (token) {
    return token;
  } else {
    console.log("/Lib/Api/index.js :: checkAccessToken :: Failed!");
  }
};

const createHeaders = (token, contentType = "application/json") => {
  const headers = {
    "Content-Type": contentType
  };
  if (token) headers.Authorization = "Bearer " + token;
  return headers;
};

const pathParamParsing = (path, parameters) => {
  let result = "";
  let pathItems = path.toString().split("/");

  pathItems.forEach((item, index) => {
    if (index !== 0) result += "/";
    if (
      item.substring(0, 1) === ":" &&
      parameters[item.substring(1, item.length)]
    ) {
      console.log(parameters[item.substring(1, item.length)]);

      result += parameters[item.substring(1, item.length)];
    } else {
      result += item;
    }
  });
  return result;
};

export const get = (path, parameters = {}) => {
  console.log("/Lib/Api/index.js :: GET :: " + apiConfig[path]);
  let realPath;
  if (typeof parameters === "object") {
    parameters.updateCallback = new Date();
  }
  realPath = pathParamParsing(apiConfig[path], parameters);

  return axios
    .get(
      apiConfig.url + realPath,
      Object.assign({ params: parameters }, apiConfig, {
        headers: createHeaders(checkAccessToken())
      })
    )
    .then(response => {
      console.log("/Lib/Api/index.js :: GET :: " + path + " :: Success!");
      return Promise.resolve(response);
    })
    .catch(err => {
      console.log("/Lib/Api/index.js :: GET :: " + path + " :: Failed!");
      //console.log(err);
      return Promise.reject(err);
    });
};
export const post = (path, parameters = {}) => {
  console.log("/Lib/Api/index.js :: POST :: " + apiConfig[path]);
  let realPath;
  if (typeof parameters === "object") {
    parameters.updateCallback = new Date();
  }
  console.log(apiConfig[path]);
  if (parameters.param) {
    realPath = apiConfig[path].replace(
      /:boardId|:optionId|:productId|:hashtagId|:userId|:commentId/g,
      parameters.param
    );
  } else {
    realPath = apiConfig[path].replace(
      /:boardId|:optionId|:productId|:hashtagId|:userId|:commentId/g,
      parameters
    );
  }

  return axios
    .post(apiConfig.url + realPath, parameters, {
      headers: createHeaders(parameters.snsToken || checkAccessToken())
    })
    .then(response => {
      console.log("/Lib/Api/index.js :: POST :: " + path + " :: Success!");
      return Promise.resolve(response);
    })
    .catch(err => {
      console.log("/Lib/Api/index.js :: POST :: " + path + " :: Failed!");
      console.log(err);
      return Promise.reject(err);
    });
};
export const put = (path, parameters = {}) => {
  console.log("/Lib/Api/index.js :: PUT :: " + apiConfig[path]);
  let realPath;
  if (typeof parameters === "object") {
    parameters.updateCallback = new Date();
  }
  console.log(apiConfig[path]);
  if (parameters.param) {
    realPath = apiConfig[path].replace(
      /:boardId|:optionId|:productId|:hashtagId|:userId|:commentId/g,
      parameters.param
    );
  } else {
    realPath = apiConfig[path].replace(
      /:boardId|:optionId|:productId|:hashtagId|:userId|:commentId/g,
      parameters
    );
  }
  return axios
    .put(apiConfig.url + realPath, parameters, {
      headers: createHeaders(checkAccessToken())
    })
    .then(response => {
      console.log("/Lib/Api/index.js :: PUT :: " + path + " :: Success!");
      return Promise.resolve(response);
    })
    .catch(err => {
      console.log("/Lib/Api/index.js :: PUT :: " + path + " :: Failed!");
      console.log(err);
      return Promise.reject(err);
    });
};

export const del = (path, parameters = {}) => {
  return axios
    .delete(
      apiConfig.url + apiConfig[path],
      Object.assign(
        { data: parameters },
        {
          headers: createHeaders(checkAccessToken())
        }
      )
    )
    .then(response => {
      console.log("/Lib/Api/index.js :: DELETE :: " + path + " :: Success!");
      return Promise.resolve(response);
    })
    .catch(err => {
      console.log("/Lib/Api/index.js :: DELETE :: " + path + " :: Failed!");
      console.log(err);
      return Promise.reject(err);
    });
};

export const upload = (path, parameters = {}) => {
  console.log("/Lib/Api/index.js :: UPLOAD :: " + apiConfig[path]);
  parameters.updateCallback = new Date();
  const body = new FormData();
  for (let file of parameters.file) {
    body.append("file", file);
  }

  return axios
    .post(apiConfig.url + apiConfig[path], body, {
      headers: createHeaders(checkAccessToken(), "multipart/form-data")
    })
    .then(response => {
      console.log("/Lib/Api/index.js :: UPLOAD :: " + path + " :: Success!");
      return Promise.resolve(response);
    })
    .catch(err => {
      console.log("/Lib/Api/index.js :: UPLOAD :: " + path + " :: Failed!");
      console.log(err);
      return Promise.reject(err);
    });
};

// 참조문서1: axios => https://github.com/mzabriskie/axios
